import { searchStore } from 'owa-mail-search-store';
export default function isAttachmentRefinerApplied() {
    return searchStore.includeAttachments;
}
//# sourceMappingURL=isAttachmentsRefinerApplied.js.map